import styled from 'styled-components';

export const StyledTYPDarkModeContainer = styled.div`
    .dark-image-toggle{
        padding-bottom: 0px;
    }
`;